import React, { useState } from 'react';
import PartsPicker from './PartsPicker';
import { SerializedWorkPicker } from './SerializedWorkPicker';

export const WorkPartsFields = ({ parts, onPartsChange, serialized, onSerializedChange, machineryId, disabled }) => {
  const [query, setQuery] = useState('');
  return <div className="space-y-5 min-w-0" data-testid="work-parts-fields">
    <div className="space-y-2">
      <h3 className="text-sm font-semibold">Bulk parts consumed</h3>
      <PartsPicker value={parts} onChange={onPartsChange} disabled={disabled} onSelectSerialized={setQuery} />
    </div>
    <SerializedWorkPicker value={serialized} onChange={onSerializedChange} machineryId={machineryId}
      disabled={disabled} query={query} setQuery={setQuery} />
  </div>;
};